import { decodeHTML } from 'entities';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { deletePAIAC010, putPAIAC010 } from '../../services/Api';
import { formatDate, getResultText } from '../../utils';
import { MESSAGE } from '../constants/app';
import useWindowWidth from '../hooks/useWindowWidth';

const ApplyItem = ({ item, type, onRefresh }) => {
    const currentDay = moment();

    const handleCancel = (seq) => {
        if (window.confirm('정말로 지원 취소하시겠습니까?')) {
            putPAIAC010(seq)
                .then(() => {
                    window.alert('지원 취소되었습니다.');
                    onRefresh();
                })
                .catch((error) => console.log(error));
        }
    };

    const handleDelete = (seq) => {
        if (window.confirm(MESSAGE.confirm.delete)) {
            deletePAIAC010(seq)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    onRefresh();
                })
                .catch((error) => console.log(error));
        }
    };
    const windowWidth = useWindowWidth();

    if (type === 'li') {
        return (
            <>
                {windowWidth <= 435 ? (
                    <li>
                        <div className="column name-clinic">{item.recCompany}</div>
                        <div className="column start support-details">
                            <h4
                                className="item-title"
                                onClick={(e) => {
                                    if (item.recSeq) {
                                        const newWindow = window.open(
                                            `/pajac051-${item.recSeq}`,
                                            '_blank',
                                            'width=1200,height=1000',
                                        );
                                        if (!newWindow) {
                                            e.preventDefault();
                                        }
                                    } else {
                                        window.alert('만료된 채용공고입니다.');
                                    }
                                }}
                            >
                                {decodeHTML(item.recTitle)}
                            </h4>
                            <div className="link-to-details">
                                <Link
                                    onClick={(e) => {
                                        if (item.resSeq) {
                                            const newWindow = window.open(
                                                `/paiab030-${item.resSeq}`,
                                                '_blank',
                                                'width=1200,height=1000',
                                            );
                                            if (!newWindow) {
                                                e.preventDefault();
                                            }
                                        } else {
                                            window.alert('이 이력서를 삭제되었습니다.');
                                        }
                                    }}
                                >
                                    지원 이력서 보기
                                </Link>
                            </div>
                        </div>
                        <div className="column management">
                            {item.resCancel === 'N' && item.result === 'W' && item.acceptYN === 'N' && (
                                <button className="management-button" onClick={() => handleCancel(item.seq)}>
                                    지원취소
                                </button>
                            )}
                            {(item.result === 'P' ||
                                item.result === 'F' ||
                                item.resCancel === 'Y') && (
                                    <button className="management-button" onClick={() => handleDelete(item.seq)}>
                                        삭제
                                    </button>
                                )}
                        </div>
                        <div className="column application-result">
                            <div className={`application-result-status ${item.result === 'P' ? 'blue' : ''}`}>
                                {getResultText(item.result)}
                            </div>
                        </div>
                        <div className="column status-progress">
                            {!item.statusFlag ||
                                (item.statusFlag !== 'O' && currentDay.isAfter(item.recRecruitEnd)) ? (
                                <div className="status-text">접수마감</div>
                            ) : (
                                <>
                                    <div className="status-text">진행중</div>
                                    <div className="status-time">(~{moment(item.recRecruitEnd).format('MM.DD')})</div>
                                </>
                            )}
                        </div>
                        <div className="column view">
                            <div className="view-status">{item.acceptYN === 'Y' ? '열람' : '미열람'}</div>
                            {item.acceptYN === 'Y' && <div className="view-time">{formatDate(item.acceptDate)}</div>}
                        </div>
                    </li>
                ) : (
                    // width> 425px
                    <li>
                        <div className="column name-clinic">{item.recCompany}</div>
                        <div className="column start support-details">
                            <h4
                                className="item-title"
                                onClick={(e) => {
                                    if (item.recSeq) {
                                        const newWindow = window.open(
                                            `/pajac051-${item.recSeq}`,
                                            '_blank',
                                            'width=1200,height=1000',
                                        );
                                        if (!newWindow) {
                                            e.preventDefault();
                                        }
                                    } else {
                                        window.alert('만료된 채용공고입니다.');
                                    }
                                }}
                            >
                                {decodeHTML(item.recTitle)}
                            </h4>
                            <div className="link-to-details">
                                <Link
                                    onClick={(e) => {
                                        if (item.resSeq) {
                                            const newWindow = window.open(
                                                `/paiab030-${item.resSeq}`,
                                                '_blank',
                                                'width=1200,height=1000',
                                            );
                                            if (!newWindow) {
                                                e.preventDefault();
                                            }
                                        } else {
                                            window.alert('이 이력서를 삭제되었습니다.');
                                        }
                                    }}
                                >
                                    지원 이력서 보기
                                </Link>
                            </div>
                        </div>
                        <div className="column status-progress">
                            {!item.statusFlag ||
                                (item.statusFlag !== 'O' && currentDay.isAfter(item.recRecruitEnd)) ? (
                                <div className="status-text">접수마감</div>
                            ) : (
                                <>
                                    <div className="status-text">진행중</div>
                                    <div className="status-time">(~{moment(item.recRecruitEnd).format('MM.DD')})</div>
                                </>
                            )}
                        </div>
                        <div className="column view">
                            <div className="view-status">{item.acceptYN === 'Y' ? '열람' : '미열람'}</div>
                            {item.acceptYN === 'Y' && <div className="view-time">{formatDate(item.acceptDate)}</div>}
                        </div>
                        <div className="column application-result">
                            <div className={`application-result-status ${item.result === 'P' ? 'blue' : ''}`}>
                                {getResultText(item.result)}
                            </div>
                        </div>
                        <div className="column management">
                            {item.resCancel === 'N' && item.result === 'W' && item.acceptYN === 'N' && (
                                <button className="management-button" onClick={() => handleCancel(item.seq)}>
                                    지원취소
                                </button>
                            )}
                            {(item.result === 'P' ||
                                item.result === 'F' ||
                                item.resCancel === 'Y') && (
                                    <button className="management-button" onClick={() => handleDelete(item.seq)}>
                                        삭제
                                    </button>
                                )}
                        </div>
                    </li>
                )}
            </>
        );
    } else if (type === 'tr') {
        return (
            <>
                <tr>
                    <td>{formatDate(item.applyDate)}</td>
                    <td>
                        <span className={`${item.result === 'P' ? 'rsm-stt__result-pass' : ''}`}>
                            {getResultText(item.result)}
                        </span>
                    </td>
                    <td>{item.recCompany}</td>
                    <td className="text-left">
                        <div className="rsm-stt__tit">
                            <div
                                onClick={(e) => {
                                    if (item.recSeq) {
                                        const newWindow = window.open(
                                            `/pajac051-${item.recSeq}`,
                                            '_blank',
                                            'width=1200,height=1000',
                                        );
                                        if (!newWindow) {
                                            e.preventDefault();
                                        }
                                    } else {
                                        window.alert('만료된 채용공고입니다.');
                                    }
                                }}
                                className="rsm-stt__link"
                            >
                                {decodeHTML(item.recTitle)}
                            </div>
                            <Link
                                onClick={(e) => {
                                    if (item.resSeq) {
                                        const newWindow = window.open(
                                            `/paiab030-${item.resSeq}`,
                                            '_blank',
                                            'width=1200,height=1000',
                                        );
                                        if (!newWindow) {
                                            e.preventDefault();
                                        }
                                    } else {
                                        window.alert('이 이력서를 삭제되었습니다.');
                                    }
                                }}
                            >
                                지원 이력서 보기
                            </Link>
                        </div>
                    </td>
                    <td>
                        {!item.statusFlag ||
                            (item.statusFlag !== 'O' && currentDay.isAfter(item.recRecruitEnd)) ? (
                            '접수마감'
                        ) : (
                            <>
                                진행중
                                <br />
                                (~{moment(item.recRecruitEnd).format('MM.DD')})
                            </>
                        )}
                    </td>
                    <td>
                        <div className="view-status">{item.acceptYN === 'Y' ? '열람' : '미열람'}</div>
                        {item.acceptYN === 'Y' && <div className="view-time">{formatDate(item.acceptDate)}</div>}
                    </td>
                    <td>
                        {item.resCancel === 'N' && item.result === 'W' && item.acceptYN === 'N' && (
                            <button className="management-button" onClick={() => handleCancel(item.seq)}>
                                지원취소
                            </button>
                        )}
                        {(item.result === 'P' ||
                            item.result === 'F' ||
                            item.resCancel === 'Y') && (
                                <button className="management-button" onClick={() => handleDelete(item.seq)}>
                                    삭제
                                </button>
                            )}
                    </td>
                </tr>
            </>
        );
    }
};

export default ApplyItem;
